export default __webpack_public_path__ + "static/media/trash-red-icon.5f7a754c.svg";